import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartBar } from '@fortawesome/free-solid-svg-icons'

const DatumSidebar = () => {
  const { pathname: currentPath } = useLocation()
  const navigate = useNavigate()

  const isActive = (path) => currentPath.startsWith(path)

  const handleNav = (e, path) => {
    e.preventDefault()
    navigate(path)
  }

  return (
    <nav className="datum-sidebar">
      <div className="mt-3">
        <ul className="nav flex-column">
          <li className="nav-item">
            <a
              href="/datum/reports"
              data-testid="sidebar-link-datum-reports"
              onClick={(e) => handleNav(e, '/datum/reports')}
              className={`datum-nav-link ${isActive('/datum/reports') || currentPath === '/datum' ? 'active' : ''}`}
            >
              <FontAwesomeIcon icon={faChartBar} className="me-2" />
              Reports
            </a>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default DatumSidebar
